module.exports = __webpack_public_path__ + "img/package_image.e4df944a.png";